import _ from 'lodash'
import * as largeView from './large'
import config from './config.json'
import siteConfig from '../../abt-core/site-config.json'
import { composeTest } from '../../abt-utils/structure'

var liveConfig = _.find(window[siteConfig.imgServerConfig], { id: 'abt610' }) || {}

export default composeTest(config, liveConfig, {
  largeView: largeView,
  smallView: largeView
})



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt610/test.js
 ** module id = 64
 ** module chunks = 2
 **/